import { createAction } from '@reduxjs/toolkit';

export const replaceCardOnboardingMaterial = createAction(
    'STORE::CARD_ONBOARDING_MATERIAL::REPLACE',
);
